export const loadItem = (name: string) => {
  try {
    const authToken =
      window.localStorage.getItem(name) ||
      window.sessionStorage.getItem(name);
    if (authToken === null) {
      return '';
    }
    return authToken;
  } catch (err) {
    return alert('Sorry but your browser does not support localStorage.');
  }
};

export const saveItem = (name: string, token: string, persistent: boolean) => {
  try {
    persistent
      ? window.localStorage.setItem(name, token)
      : window.sessionStorage.setItem(name, token);
  } catch (err) {
    return alert('Sorry but your browser does not support localStorage.');
  }
};

export const removeItem = (name: string) => {
  try {
    window.localStorage.removeItem(name);
    window.sessionStorage.removeItem(name);
  } catch (err) {
    return alert('Sorry but your browser does not support localStorage.');
  }
};
